import { render, staticRenderFns } from "./newOrganization.vue?vue&type=template&id=05817d93&scoped=true&"
import script from "./newOrganization.vue?vue&type=script&lang=js&"
export * from "./newOrganization.vue?vue&type=script&lang=js&"
import style0 from "./newOrganization.vue?vue&type=style&index=0&id=05817d93&scoped=true&lang=css&"
import style1 from "./newOrganization.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05817d93",
  null
  
)

export default component.exports